import { create } from 'zustand';

interface ImageModalState {
  showModal: boolean;
  imageModalOpen: boolean;
  initialImage: number;
  openImageModal: (index: number) => void;
  closeImageModal: () => void;
}

export const useImageModalStore = create<ImageModalState>(set => ({
  showModal: false,
  imageModalOpen: false,
  initialImage: 0,

  openImageModal: (index: number) => {
    set({ imageModalOpen: true, initialImage: index });
  },
  closeImageModal: () => {
    set({ imageModalOpen: false });
  },
}));
